import { render } from "./OrderNotesModal.vue?vue&type=template&id=fca37380&scoped=true"
import script from "./OrderNotesModal.vue?vue&type=script&lang=js"
export * from "./OrderNotesModal.vue?vue&type=script&lang=js"

import "./OrderNotesModal.vue?vue&type=style&index=0&id=fca37380&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fca37380"]])

export default __exports__